import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import _get from 'lodash/get';
import classnames from 'classnames';

import { Table } from '@devexpress/dx-react-grid-material-ui';

export const ProductTableCell = ({ classes, t, props }) => {
  const { column, row = {} } = props;
  if (column.name === 'isHazMatValue' && row.isHazMat) {
    return (
      <Table.Cell className={classes.hazMatCell} {...props}>
        {row.isHazMatValue}
        <Tooltip
          title={
            <div>
              <p className={classes.noMargin}>
                <strong>{t('Shipping Name')}</strong>:{' '}
                {_get(row, 'hazMat.properShippingName', '')}
              </p>
              <p className={classes.noMargin}>
                <strong>{t('HazMat Class')}</strong>:{' '}
                {_get(row, 'hazMatClass', '')}
              </p>
              <p className={classes.noMargin}>
                <strong>{t('UN/NA')}</strong>:{' '}
                {_get(row, 'hazMat.unNumber', '')}
              </p>
              <p className={classes.noMargin}>
                <strong>{t('Package Group')}</strong>:{' '}
                {_get(row, 'hazMatPackingGroup', '')}
              </p>
              <p className={classes.noMargin}>
                <strong>{t('Contact Name')}</strong>:{' '}
                {`${_get(row, 'hazMat.contactFirstName', '')} ${_get(
                  row,
                  'hazMat.contactLastName',
                  ''
                )}`}
              </p>
              <p className={classes.noMargin}>
                <strong>{t('Contact Phone')}</strong>:{' '}
                {_get(row, 'hazMat.contactPhone', '')}
              </p>
            </div>
          }
          classes={{
            tooltip: classnames(classes.caption, classes.tooltip),
            popper: classes.tooltipPopper
          }}
          placement="bottom-start"
        >
          <IconButton
            disableRipple={true}
            className={classes.hazMatInfoButtonRoot}
          >
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Table.Cell>
    );
  }
  return (
    <Table.Cell {...props}>{_get(row, column.name, '--') || '--'}</Table.Cell>
  );
};

export default ProductTableCell;
